import { PaymentType } from "../types/PaymentType";

export const mapPaymentMethod = (key: string | undefined): string => {
    switch (key) {
        case PaymentType.ABO_DIRECTDEBIT:
            return "APP_ROOT.PAYMENT_TYPE.DIRECT_DEBIT";
        case PaymentType.ABO_BANKTRANSFER:
            return "APP_ROOT.PAYMENT_TYPE.BANK_TRANSFER";
        case PaymentType.ABO_PAYPAL:
            return "APP_ROOT.PAYMENT_TYPE.PAYPAL";
        case PaymentType.ABO_CREDITCARD:
            return "APP_ROOT.PAYMENT_TYPE.CREDITCARD";
        default:
            return "";
    }
};
